import { render, staticRenderFns } from "./fixProgram.vue?vue&type=template&id=2bf6ddfc&"
import script from "./fixProgram.vue?vue&type=script&lang=js&"
export * from "./fixProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports